// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"b742c3f1","593":"4c42336d"}[chunkId] + ".css";
};